import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenUrlLinkList from './OpenUrlLinkList';
import Card from '../Card/Card';
import Identifiers from '../Identifiers/Identifiers';
import BounceLoader from '../BounceLoader';
import { getUrlResolvers } from '../../actions/url-resolvers';

if (process.browser) require('./FindThisPaper.scss');

const mapStateToProps = ({ session: { isAuthenticated }, urlResolvers }) =>
  ({ isAuthenticated, urlResolvers });
const mapDispatchToProps = { getResolvers: getUrlResolvers };

const CARD_TITLE = 'Find this document';

const emptyResult = ({ length }) => length !== undefined && length < 1;
const isErrorWithTimeout = urlResolvers =>
  (urlResolvers && urlResolvers.error && urlResolvers.timeout);
const isFetching = urlResolvers => urlResolvers && urlResolvers.fetching;

const fetchData = ({ isAuthenticated, urlResolvers, getResolvers }, retryTimeout = false) => {
  if (
    isAuthenticated &&
    !isFetching(urlResolvers) &&
    (!urlResolvers || (isErrorWithTimeout(urlResolvers) && retryTimeout))
  ) {
    getResolvers();
  }
};

const CardContent = ({
  isAuthenticated, doc, doc: { identifiers, id }, urlResolvers
}) => {
  const identifiersComponent = <Identifiers identifiers={identifiers} documentId={id} />;
  if (!isAuthenticated) return identifiersComponent;

  if (!urlResolvers || urlResolvers.fetching) return <BounceLoader />;

  if (emptyResult(urlResolvers)) return identifiersComponent;

  if (urlResolvers.error) return identifiersComponent;

  return <OpenUrlLinkList doc={doc} urlResolvers={urlResolvers} />;
};

class FindThisPaperContainer extends Component {
  componentWillMount() {
    fetchData(this.props, process.browser);
  }

  render() {
    return (
      <Card title={CARD_TITLE} data-name="find-this-paper">
        <CardContent {...this.props} />
      </Card>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FindThisPaperContainer);



// WEBPACK FOOTER //
// ./src/universal/ui/components/FindThisPaper/FindThisPaper.js